/*
  Hover-to-open for the header dropdowns.

  Dawn builds each dropdown as <details><summary>, which only opens on click.
  This opens it on hover instead, but only where hovering is a real input:
  a touch screen reports no hover, and there the original tap behaviour is
  left completely alone.

  Keyboard use is untouched — focus still opens the menu through the native
  summary, and Escape closes it.
*/
(function () {
  'use strict';

  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  // Closing is delayed so that moving the pointer diagonally from the summary
  // into the panel doesn't clip a corner and shut the menu mid-movement.
  var CLOSE_DELAY = 180;

  function menus() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.header__inline-menu details')
    );
  }

  function firstLink(details) {
    // The first real destination inside this menu's own panel. Nested groups
    // use <summary>, not <a>, so those are skipped and the first genuine link
    // in reading order wins.
    var panel = details.querySelector(':scope > ul');
    return panel ? panel.querySelector('a[href]') : null;
  }

  function close(details) {
    if (!details.open) return;
    details.open = false;
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function open(details) {
    if (details.open) return;
    details.open = true;
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function closeSiblings(details) {
    menus().forEach(function (other) {
      // Leave ancestors alone, or opening a nested menu would shut its parent.
      if (other !== details && !other.contains(details)) close(other);
    });
  }

  function bind(details) {
    if (details.dataset.hoverBound === '1') return;
    details.dataset.hoverBound = '1';

    details.addEventListener('mouseenter', function () {
      if (!FINE.matches) return;
      clearTimeout(details._hoverTimer);
      closeSiblings(details);
      open(details);
    });

    details.addEventListener('mouseleave', function () {
      if (!FINE.matches) return;
      clearTimeout(details._hoverTimer);
      details._hoverTimer = setTimeout(function () {
        close(details);
      }, CLOSE_DELAY);
    });

    var summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', function (event) {
        if (!FINE.matches) return;

        // A keyboard Enter/Space also arrives here as a click, but with no
        // pointer behind it. Navigating on those would make the submenu
        // unreachable by keyboard, so they keep the native open/close.
        if (event.detail === 0) return;

        // Hovering already reveals the stack, so a deliberate click means
        // "take me there" — the first entry is the parent's real destination.
        var first = firstLink(details);
        if (!first) {
          event.preventDefault();
          open(details);
          return;
        }

        event.preventDefault();
        if (event.metaKey || event.ctrlKey || event.shiftKey) {
          window.open(first.href, '_blank', 'noopener');
          return;
        }
        window.location.href = first.href;
      });
    }
  }

  function bindAll() {
    menus().forEach(bind);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    menus().forEach(close);
  });

  // Any pointer press outside the header dismisses whatever is open.
  document.addEventListener('pointerdown', function (event) {
    if (event.target.closest && event.target.closest('.header__inline-menu')) return;
    menus().forEach(close);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  // The header re-renders in the theme editor and after section reloads.
  document.addEventListener('shopify:section:load', bindAll);
})();
